module.exports = __webpack_public_path__ + "18d644b5a55ae97188ed97dcb29e573e.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/goldencity21.jpg
// module id = 631
// module chunks = 0